import React from 'react';

const initialValues = {
  failedSteps: [],
  bugsReported: [],
  historyDetails: {},
};

export const ExecutionHistoryContext = React.createContext(initialValues);
